import { Component, OnInit } from '@angular/core';
import { RestService } from '../../../../../services/rest.service';
import { RouteService } from '../../../../../services/route.service';
import { environment } from '../../../../../../environments/environment';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { ModalComponent } from '../../../../../models/modal-component';
import { LastUsedBooksComponent } from './last-used-books/last-used-books.component';

@Component({
    selector: 'app-my-books-modal',
    templateUrl: './my-books-modal.component.html',
    styleUrls: ['./my-books-modal.component.scss'],
    standalone: true,
    imports: [
        LastUsedBooksComponent
    ]
})
export class MyBooksModalComponent extends ModalComponent implements OnInit {
    static MODAL_ID = 'myBooksModal';

    seriesBooks: Array<{
        title: string;
        url: string;
        cover: string;
        isbn: string;
        edition: number;
        editionyear: number;
    }>;

    constructor(public applicationStateService: ApplicationStateService,
                private restService: RestService,
                private routeService: RouteService) {
        super();
    }

    ngOnInit(): void {
        const route = this.routeService.getRelativeRoute(environment.endpointUrls.bookSeries,
            { bookId: this.applicationStateService.bookId });

        this.restService.get(route).then(result => {
            this.seriesBooks = result.sort((a,b) => a.title.localeCompare(b.title));
        }).catch(() => {
            this.seriesBooks = [];
        });
    }

    getId(): string {
        return MyBooksModalComponent.MODAL_ID;
    }
}
